module.exports = __webpack_public_path__ + "static/media/PB_Y_07.b58d8383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_07.png
// module id = 236
// module chunks = 0